import { render, staticRenderFns } from "./List.vue?vue&type=template&id=67b7385a&"
import script from "./List.vue?vue&type=script&lang=js&"
export * from "./List.vue?vue&type=script&lang=js&"
import style0 from "./List.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67b7385a')) {
      api.createRecord('67b7385a', component.options)
    } else {
      api.reload('67b7385a', component.options)
    }
    module.hot.accept("./List.vue?vue&type=template&id=67b7385a&", function () {
      api.rerender('67b7385a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/point/PointQuotaLimit/List.vue"
export default component.exports